import api from '@api/Apis';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import { addToCartMethod, isLoginCheck, _getAllProduct } from '@Components/Common/CommonMethods';
import _ from 'lodash';
import Cookie from 'js-cookie';
import * as Sentry from "@sentry/react";
import Cookies from 'js-cookie';


const useKitFormHook = (props) => {

    const router = useRouter()
    // common states and methods
    const [alreadyConcentMsg, setAlreadyConcentMsg] = useState('');
    const [alreadyExistUser, setAlreadyExistUser] = useState();
    const [openConsentOption, setOpenConsentOption] = useState(false);
    const [chooseOption, setChooseOption] = useState(null);
    const [refferalCode, setRefferralCode] = useState(null);
    const [storeShippingData, setStoreShippingData] = useState(null);
    const [openKitPopup, setOpenKitPopup] = useState(false);
    async function _handleCheckUserConsent(email) {
        await api.checkUserConsent({ email: email }).then((res) => {
            if (res?.data?.code === 1) {
                setAlreadyConcentMsg(res?.data?.message);
                setAlreadyExistUser(res?.data?.alreadyExist);
            }
            else if (res?.data?.code === 0) {
                setAlreadyConcentMsg(res?.data?.message);
                setAlreadyExistUser(res?.data?.alreadyExist);
            }
        }).catch((err) => console.log(err))
    }

    //********************** >> kitOrderListingSection << **************************//
    const [barCodeValue, setBarCodeValue] = useState(null);
    const [storeBarcode, setStoreBarcode] = useState(null);
    const [freeKitProduct, setFreeKitProduct] = useState([]);
    const [duplicateFreeKitProduct, setDuplicateFreeKitProduct] = useState([]);
    const [isBarcodeAutoship, setIsBarcodeAutoShip] = useState(false);
    const [isBundleProduct, setIsBundleProduct] = useState();

    useEffect(() => {
        if (!barCodeValue && !localStorage.getItem("consentForm")) {
            router.push('/us/kit_form/');
        }
        else if (!barCodeValue && localStorage.getItem("consentForm")) {
            router.push('/us/kit_form/?checkout');
        }
        if (chooseOption) {
            setBarCodeValue(storeBarcode);
            setFreeKitProduct(duplicateFreeKitProduct);
        }
    }, [barCodeValue, chooseOption])

    async function handleSubmit(data, setError) {
        props?.setInnerLoader(true);
        const token = localStorage.getItem('Token') ? localStorage.getItem('Token') : null;
        await api.searchbarcode(token, { barcode: data?.barCode }).then((res) => {
            if (res?.status === 200) {
                if (res?.data?.code === 1) {
                    setIsBundleProduct(res?.data?.bundle_product);
                    if (res?.data?.bundle_product) {
                        Cookies.set("shareconsent", true);
                    }

                    localStorage.setItem("barcode", data?.barCode);
                    router?.push("/us/kit_form/?checkout")
                    if (isLoginCheck()) {
                        setStoreBarcode(data?.barCode);
                        setOpenConsentOption(true);
                        if (res?.data?.products_data?.length > 0) {
                            setDuplicateFreeKitProduct(res?.data?.products_data);
                        }
                    } else {
                        setBarCodeValue(data?.barCode);
                        if (res?.data?.products_data?.length > 0) {
                            setFreeKitProduct(res?.data?.products_data);
                        }
                    }
                    setRefferralCode(res?.data?.parentReferral);
                    setIsBarcodeAutoShip(data?.autoship_order);

                    if (res?.data?.products_data?.length > 0) {
                        setDuplicateFreeKitProduct(res?.data?.products_data);
                    }
                    props?.setInnerLoader(false);
                }
                if (res?.data?.code === 0) {
                    setError("barCode", { type: "custom", message: res?.data?.message, already_registered_a_kit: res?.data?.already_registered_a_kit }, { shouldFocus: true });
                    props?.setInnerLoader(false);
                    if (res?.data?.already_registered_a_kit) {
                        setOpenKitPopup(true)
                    }
                }
            } else {
                props?.setInnerLoader(false);
            }

        })
    }

    // ************************** >> mySelffForm << ***********************************

    const [imageError, setImageError] = useState('');
    const [success, setSuccess] = useState('');
    const [errorKitMsg, setErrorKitMsg] = useState('');

    function mySelfFormSubmit(data, sigCanvas) {

        // props?.setInnerLoader(true);
        const CHECK_CONDITION = sigCanvas.current?.isEmpty();
        let SIGNATURE = '';
        if (!CHECK_CONDITION) {
            SIGNATURE = sigCanvas.current?.getTrimmedCanvas().toDataURL("image/png");
        }
        // data['show_to_professional'] = !isBundleProduct && null;
        if (CHECK_CONDITION) {
            setImageError("this field is required.")
            props?.setInnerLoader(false);
        } else {
            setImageError('');
            data.e_signature = SIGNATURE;
            data['user'] = _.find(props?.kitListing, { order: +router?.query?.order_id })?.user;
            data['barcode'] = localStorage?.getItem("barcode") ? localStorage?.getItem("barcode") : barCodeValue;
            data['phone_number'] = data?.phone_number;

            props.setInnerLoader(true);
            if (!isLoginCheck()) {
                const DATA = localStorage.getItem('logincredentials') ? JSON.parse(localStorage.getItem('logincredentials')) : "";
                api.loginUser({ email: DATA?.new_email, password: DATA?.new_password }).then((res) => {
                    if (res?.data?.code === 1) {
                        localStorage.setItem("Token", res.data.token);
                        Sentry.setUser({ id: res?.data?.user_data?.userdetails?.[0]?.public_user_id, email: res?.data?.user_data?.email });
                        api.consentformApi(data).then((res) => {
                            if (res?.data?.code === 1) {
                                props?.setInnerLoader(false);
                                // localStorage.removeItem("profileData")
                                router.push({ pathname: '/us/kit_form', query: { r: 'success' } })

                            }
                            else if (res?.data?.code === 0) {
                                props?.setInnerLoader(false);
                                setErrorKitMsg(res?.data?.message)
                            }
                        }).catch((err) => {
                            props?.setInnerLoader(false);
                            throw new Error('Error occuring on kitFormHook');
                        })
                        localStorage.setItem("Token", res.data.token);
                        router.push({ pathname: '/us/kit_form', query: { r: 'success' } });
                        props?.setInnerLoader(false);
                    } else {
                        props?.setInnerLoader(false);
                    }
                });
            }
            else {
                api.consentformApi(data).then((res) => {
                    if (res?.data?.code === 1) {
                        props?.setInnerLoader(false);
                        // localStorage.removeItem("profileData")
                        router.push({ pathname: '/us/kit_form', query: { r: 'success' } });
                    }
                    else if (res?.data?.code === 0) {
                        props?.setInnerLoader(false);
                        setErrorKitMsg(res?.data?.message)
                    }
                }).catch((err) => {
                    props?.setInnerLoader(false);
                    throw new Error('Error occuring on kitFormHook');
                })
            }
        }
    }

    //************************** >> otherForm << ***********************************

    const [otherSuccessMsg, setOtherSuccessMsg] = useState('');
    const [otherImageError, setOtherImageError] = useState('');
    const [errorOtherKitMsg, setErrorOtherKitMsg] = useState('');

    function otherFormSubmit(data, sigCanvas) {
        props?.setInnerLoader(true);
        const CHECK_CONDITION = sigCanvas.current?.isEmpty();
        let SIGNATURE = '';
        if (!CHECK_CONDITION) {
            SIGNATURE = sigCanvas.current?.getTrimmedCanvas().toDataURL("image/png");
        }
        data['barcode'] = localStorage?.getItem("barcode") ? localStorage?.getItem("barcode") : barCodeValue;
        // data['show_to_professional'] = !isBundleProduct && null;
        if (CHECK_CONDITION) {
            setOtherImageError("this field is required.")
            props?.setInnerLoader(false);
        } else {
            setOtherImageError('');
            data.e_signature = SIGNATURE;
            props.setInnerLoader(true)
            api.consentOtherApi(data).then((res) => {
                if (res?.data?.code === 1) {
                    if (isLoginCheck()) {
                        props?.setInnerLoader(false);
                        router.push({ pathname: '/us/kit_form', query: { r: 'success' } });
                    } else {
                        api.loginUser({
                            email: data?.email,
                            password: data?.password
                        }).then((res) => {
                            if (res?.data?.code === 1) {
                                localStorage.setItem("Token", res.data.token);
                                Sentry.setUser({ id: res?.data?.user_data?.userdetails?.[0]?.public_user_id, email: res?.data?.user_data?.email });
                                router.push({ pathname: '/us/kit_form', query: { r: 'success' } });
                                props?.setInnerLoader(false);
                            } else {
                                props?.setInnerLoader(false);
                            }
                        });
                    }
                } else {
                    setErrorOtherKitMsg(res?.data?.message || "server Error")
                    props.setInnerLoader(false);
                }
            })
        }
    };

    //**************************** >> kit Success << ********************************** 
    const [frequencyDate, setFrequencyDate] = useState(null);
    const [quantity, setQuantity] = useState(null);
    const [checkedProduct, setCheckedProduct] = useState(null);
    const [frequentlyProduct, setFrequentlyProduct] = useState(null);
    const [streetData, setStreetData] = useState(null);
    useEffect(() => {
        Promise.resolve(_getAllProduct(true)).then((res) => {
            if (res?.length > 0) {
                const VALUES = _.map(res, (row) => ({
                    id: +row?.id,
                    autoship_cost_price: +row?.autoship_cost_price,
                    cost_price: +row?.cost_price,
                    image: (row?.product_images?.length > 0) ? row?.product_images[0]?.image : "/media/products/2022/11/30/Screenshot_from_2022-11-18_13-00-44.png",
                    name: row?.name,
                    quantity: +row?.quantity,
                    sku: row?.sku,
                    tax_code: row?.tax_code,
                    weight: row?.weight
                }))
                setFrequentlyProduct(VALUES);
                setQuantity(_.map(res, (row) => ({ id: +row?.id, qty: 1, maxQty: +row?.quantity })));
                setFrequencyDate(_.map(res, (row) => ({ id: +row?.id, autoship: "one-time" })));
            }
        });
    }, []);


    function onQtyfuntion(section, id) {
        const QTY = _.find(quantity, { id: id });
        const MAX_QTY = QTY?.maxQty;
        const CURRENT_QTY = QTY?.qty;

        if (section === "add") {
            if (CURRENT_QTY < MAX_QTY) {
                QTY['qty'] = QTY?.qty + 1;
                const REJECTED_DATA = _.reject(quantity, QTY);
                setQuantity([...REJECTED_DATA, QTY]);
            }
        } else {
            if (CURRENT_QTY !== 1) {
                QTY['qty'] = QTY?.qty - 1;
                const REJECTED_DATA = _.reject(quantity, { id: id });
                setQuantity([...REJECTED_DATA, QTY]);
            }
        }
    }

    function setAutoshipFunction(event, id) {
        const FIND_VALUE = _.find(frequencyDate, { id: id });
        if (FIND_VALUE) {
            FIND_VALUE['autoship'] = event.target.value;
            const REMAIN_DATA = _.reject(frequencyDate, FIND_VALUE);
            setFrequencyDate([...REMAIN_DATA, FIND_VALUE]);
        }
    }


    //**************************** >> kit Checkout << ********************************** 

    const [savedCard, setSavedCard] = useState()
    const [errorCheck, setErrorCheck] = useState("");
    const [discountValues, setDiscountValue] = useState(null);
    const [amountCalculations, setAmountCalculations] = useState()
    function _getSavedCards(token) {
        api.getSavedCards(token).then((res) => {
            if (res?.data?.code === 1) {
                setSavedCard(res?.data)
            }
        });
    }
    useEffect(() => {
        let token = localStorage.getItem("Token");
        _getSavedCards(token);
        // const alreadyExistCoupon = localStorage.getItem('coupon_name');
        // setDiscountValue({ couponCode: alreadyExistCoupon ? alreadyExistCoupon : '', amount: null, error: "" });
    }, []);

    function removedCoupon() {
        setDiscountValue({ couponCode: '', amount: null, error: "" });
    }
    function appliedCouponFunc(totalAmount) {
        const Ids = _.map(freeKitProduct, ({ id }) => +id);
        props.setInnerLoader(true);
        let token = localStorage.getItem("Token");
        if (discountValues?.couponCode !== "") {
            let orderdata = {
                coupon: discountValues?.couponCode, shipping_id: null, is_bulk_discount: true, products: Ids,
                autoshipStatus: [false], quantity: Ids, referral_code: Cookie.get('refferal-code')?.length > 0 ? Cookie.get('refferal-code') : "",
            };

            api.verifycoupon(orderdata, token).then(res => {
                setAmountCalculations(res?.data?.amountCalculations)
                if (res?.data?.code === 1) {
                    // localStorage.setItem('coupon_name', res.data.coupon_details?.code)
                    if (res?.data?.coupon_details?.discount_type === 1) {
                        setDiscountValue((prv) => ({ ...prv, amount: +res?.data?.coupon_details.discount_amount }));
                        // setFreeShipping(false);
                    }
                    if (res?.data?.coupon_details?.discount_type === 2) {
                        setDiscountValue((prv) => ({ ...prv, amount: +(totalAmount * res?.data?.coupon_details.discount_percent) / 100 }));
                    }

                    if (res?.data?.coupon_details?.free_shipping === true) {
                        setDiscountValue((prv) => ({ ...prv, amount: 0 }))
                        // setFreeShipping(true);
                    }

                    props.setInnerLoader(false);
                }
                else {
                    props.setInnerLoader(false);
                    setDiscountValue(({ couponCode: '', amount: null, error: res?.data?.message }));
                }
            });
        }
    }

    function handleCheckoutSubmit(data) {
        props.setInnerLoader(true);
        const orderData = {
            billing_details: {},
            barcode: barCodeValue ? barCodeValue : localStorage?.getItem("barcode"),
            shipping_details: {},
            amount_paid: parseFloat(+data?.total - (discountValues?.amount ? +discountValues?.amount : 0), 2),
            gross_total: parseFloat(+data?.total - (data?.taxPrice ? data?.taxPrice : 0), 2),
            shipping_amount: 0,
            coupon_code: discountValues?.amount ? discountValues?.couponCode : '',
            discount_amount: discountValues?.amount ? parseFloat(+discountValues?.amount, 2) : 0,
            shipping_module_id: null,
            tax_amount: data?.taxPrice ? data?.taxPrice : 0,
            products: data?.selectedProductFreq?.product_id ? [...data?.products, data?.selectedProductFreq] : data?.products,
            termscondition3: data?.termscondition3,
            payment_details: data?.payment_details,
            new_user: { ...data?.new_user, parentrefferalPromoter: refferalCode },
            saved_card_id: data?.saved_card_id,
            save_credit_card: data?.save_credit_card,
            bougth_together_product: data?.selectedProductFreq?.product_id ? true : false,
            termscondition: data?.termscondition,
            termscondition1: data?.termscondition1,
            termscondition2: data?.termscondition2
        }

        _.map(['billing', 'shipping'], (row) => {
            orderData[row + '_details'] = {
                "first_name": data[row + '_first_name'],
                "last_name": data[row + '_last_name'],
                "company_name": data[row + '_company_name'],
                "city": data[row + '_city'],
                "postal_code": data[row + '_postal_code'],
                "street_address_1": data[row + '_street_address_1'] ? data[row + '_street_address_1'] : streetData[`${row}Street`],
                "street_address_2": data[row + '_street_address_2'] ? data[row + '_street_address_2'] : "",
                "country": data[row + '_country'],
                "state": data[row + '_state'],
                "phone_number": data?._phone_number ? data?._phone_number : ""
            }
            // orderData[row + '_details'] = {
            //     "first_name": data?.billing_first_name,
            //     "last_name": data?.billing_last_name,
            //     "company_name": data?.billing_company_name,
            //     "city": data?.billing_city,
            //     "postal_code": data?.billing_postal_code,
            //     "street_address_1": data?.billing_street_address_1,
            //     "street_address_2": data?.billing_street_address_2 ? data.billing_street_address_2 : "",
            //     "country": data?.billing_country,
            //     "state": data?.billing_state,
            //     "phone_number": data?.billing_phone_number
            // }
        });
        setStoreShippingData({
            email: data?.email,
            password: data?.password,
            confirm_password: data?.password,
            ...orderData['shipping_details']
        })
        api.createOrderBarCode(orderData).then((res) => {
            if (res?.data?.code === 1) {
                setCheckoutId(res?.data?.order_id);
                props.setInnerLoader(false);
                localStorage.removeItem("consentFormCheckout")
            }
            if (res?.data?.code === 0) {
                setDuplicateFreeKitProduct();
                setErrorCheck(res?.data?.message);
                props.setInnerLoader(false);
                setTimeout(() => setErrorCheck(""), 5000);
            }
        }).catch((err) => {
            props.setInnerLoader(false);
        })
    }


    /*************************************Kit Thankyou Page************************************************ */

    const [orderedData, setOrderedData] = useState(null);
    const [publicOrderId, setPublicOrderId] = useState(null);
    const [shippingAmount, setShippingAmount] = useState(null);
    const [checkoutOrderId, setCheckoutId] = useState(null);


    async function _getOrderById(update_data) {
        await api.GetOrderDetail(update_data).then(res => {
            if (res?.data?.orders) {
                setOrderedData(res?.data?.orders?.main_order);
                // localStorage.setItem('customerinfo', JSON.stringify(res?.data?.orders?.shipping_address));
                setPublicOrderId(res?.data?.orders?.main_order?.public_order_id);
                setShippingAmount(res?.data?.orders?.main_order?.shipping_amount);
                // setTimeout(() => goToConsent(), 7000);
            }
        })
    }

    function goToConsent() {
        setCheckoutId(null);
        setFreeKitProduct(null);
    }

    useEffect(() => {
        props?.setCartData()
        const token = localStorage.getItem('Token') ? localStorage.getItem('Token') : '';
        const update_data = { token: token, order_id: checkoutOrderId, autoship_order_id: "" };
        _getOrderById(update_data);
    }, [checkoutOrderId]);

    return [
        storeShippingData,
        barCodeValue,
        setBarCodeValue,
        handleSubmit,
        mySelfFormSubmit,
        imageError,
        success,
        otherFormSubmit,
        otherSuccessMsg,
        otherImageError,
        errorOtherKitMsg,
        isBarcodeAutoship,
        quantity, frequencyDate,
        onQtyfuntion, setAutoshipFunction,
        checkedProduct, setCheckedProduct,
        frequentlyProduct, streetData, setStreetData,
        freeKitProduct, duplicateFreeKitProduct, savedCard, errorKitMsg,
        handleCheckoutSubmit, errorCheck,

        orderedData,
        publicOrderId,
        shippingAmount,
        checkoutOrderId,
        goToConsent,

        discountValues,
        setDiscountValue,
        removedCoupon,
        appliedCouponFunc,

        openConsentOption,
        setOpenConsentOption,
        chooseOption, setChooseOption, storeBarcode,
        alreadyConcentMsg,
        _handleCheckUserConsent, isBundleProduct, openKitPopup, setOpenKitPopup, alreadyExistUser, setDuplicateFreeKitProduct, setFreeKitProduct
    ]

}

export default useKitFormHook;